module.exports = __webpack_public_path__ + "static/media/studiopic.0996165a.svg";